import { render, staticRenderFns } from "./ReturnDamage.vue?vue&type=template&id=0ec0dd33&scoped=true"
import script from "./ReturnDamage.vue?vue&type=script&lang=js"
export * from "./ReturnDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0dd33",
  null
  
)

export default component.exports